module.exports = __webpack_public_path__ + "img/discard_silo_img1.bc673004.jpeg";